var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var $body = jQuery('body');

if (isSafari) {
  $body.addClass('is-safari');
}